module.exports = __webpack_public_path__ + "static/media/ic-business.16a22973.svg";